import { useMemo } from "react"

import { useTranslation } from "@l2r-front/l2r-i18n"
import { useGetAvailableSubnetworkCountForModule, useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useIsMobileDevice } from "@l2r-front/l2r-ui"

import { API_MODULE_ROADWAY, appRoad } from "../../../../common/constants/appRoad"
import { I18N_NAMESPACE } from "../../../../common/constants/i18n"
import { NotationTrendingKpi as NotationTrendingKpiComponent } from "../../components/NotationTrendingKpi/NotationTrendingKpi"
import { GLOBAL_GRADE_TYPE } from "../../constants/roadInfoConfig"
import { useRelevantNetworkGradings } from "../../hooks/queries/networkGradings/useRelevantNetworkGradings"

import * as Styled from "./NotationTrendingKpi.styled"

export function NotationTrendingKpi(props) {

    const { t } = useTranslation([I18N_NAMESPACE])
    const isMobile = useIsMobileDevice()
    const { selectedNetwork } = useNetworksStateContext()

    const currentSubNetworksWithRoadwayCount = useGetAvailableSubnetworkCountForModule(API_MODULE_ROADWAY)

    const {
        isLoading,
        isError,
        sortedRelevantNetworkGradings,
    } = useRelevantNetworkGradings(selectedNetwork?.slug)

    const gradingValues = useMemo(() => {
        return sortedRelevantNetworkGradings?.map((networkGrading) => (
            {
                grade: networkGrading.gradesWeightedAverage[GLOBAL_GRADE_TYPE],
                date: new Date(networkGrading?.year, 7, 1),
            }
        ))
    }, [sortedRelevantNetworkGradings])

    if (isError) {
        return <Styled.KpiError
            title={t(I18N_NAMESPACE, "containers.notationKpi.error")}
            id="notation-trending-kpi-error"
            message={t(I18N_NAMESPACE, "containers.notationKpi.error")}
            path={`${appRoad.path}/${appRoad.modules.roadway.path}`}
            {...props}
        />
    }

    if (isLoading) {
        return <Styled.KpiSkeleton {...props} />
    }

    return (
        <Styled.KpiCard
            draggable={false}
            id="notation-trending-kpi"
            path={`${appRoad.path}/${appRoad.modules.roadway.path}`}
            subNetworksCount={currentSubNetworksWithRoadwayCount}
            title={t(I18N_NAMESPACE, "containers.notationTrendingKpi.title")}
            titleEndAdornment={<Styled.Tooltip
                disableFocusListener
                title={t(I18N_NAMESPACE, "containers.notationTrendingKpi.desc")}
                placement={isMobile ? "left-end" : "right-end"}
                enterTouchDelay={200}
                slotProps={{
                    tooltip: { sx: { maxWidth: 200 } },
                }}
            >
                <Styled.InfoIcon />
            </Styled.Tooltip>}
            {...props}
        >

            <Styled.ChartContainer>
                <NotationTrendingKpiComponent values={gradingValues} />
            </Styled.ChartContainer>
        </Styled.KpiCard >
    )
}